export default __webpack_public_path__ + "static/media/home-furniture-shop-slider-img-03.25c9733d.png";